import documentTranslations from "./documentTranslations";
import abstractCaseTranslations from "./abstractCaseTranslations";

const deathTranslations = {
  label: "Erstberatung Erbrecht/Todesfall",
  ...documentTranslations,
  ...abstractCaseTranslations,
  generalCategory: {
    label: "Informationen zu",
    values: {
      death: "Todesfall",
      inheritance: "Erbe",
      both: "Todesfall & Erbe",
    },
  },
  deathCategory: {
    label: "Todesfall aktuell?",
    values: {
      current: "Aktuell",
      preparation: "Vorbereitung",
    },
  },
  inheritanceCategory: {
    label: "Erbe oder Vererben?",
    values: {
      heir: "Erbe",
      bequeather: "Vererben",
    },
  },
  advisoryAppointment: {
    label: "Beratungsgespräch",
  },
};

export default deathTranslations;
